export default __webpack_public_path__ + "static/johan-eliasson-19b9abe205f9b802d1ebf4fa5ca2c207.png";